import CallMedia from './CallMedia';

const CallMediaSingleton = CallMedia.getInstance();

export default CallMediaSingleton;
